// Static option lists shared by MACD Connect form + backend validation.
export const PERFIL_OPTIONS = [
  { value: "auxiliar", label: "Auxiliar" },
  { value: "profissional", label: "Profissional da beleza" },
  { value: "dono", label: "Dono de salão" },
];

export const TAMANHO_OPTIONS = [
  { value: "solo", label: "Trabalho sozinho(a)" },
  { value: "2-5", label: "2 a 5 pessoas" },
  { value: "6-15", label: "6 a 15 pessoas" },
  { value: "16+", label: "16 ou mais pessoas" },
];

export const TEMPO_OPTIONS = [
  { value: "<1", label: "Menos de 1 ano" },
  { value: "1-3", label: "1 a 3 anos" },
  { value: "4-10", label: "4 a 10 anos" },
  { value: "10+", label: "Mais de 10 anos" },
];

export const UFS = [
  "AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO",
  "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR",
  "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO",
];
